import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
const DISMISS_KEY = 'zilch_account_type_prompt_dismissed';

function AccountTypePrompt() {
  const { user, supplierInfo, getToken, refreshSupplierInfo } = useAuth();
  const [saving, setSaving] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1'
  );

  // Only show once supplierInfo has actually loaded; while it's null we don't
  // know whether account_type is missing or just not fetched yet.
  const shouldShow =
    !!user && !!supplierInfo && !supplierInfo.account_type && !dismissed;

  if (!shouldShow) return null;

  const handleSelect = async (type) => {
    setSaving(true);
    try {
      const token = await getToken();
      await axios.patch(
        `${API_BASE_URL}/suppliers/profile`,
        { account_type: type },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (refreshSupplierInfo) await refreshSupplierInfo();
    } catch (err) {
      console.error('Failed to set account type:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="account-prompt-overlay" role="dialog" aria-modal="true">
      <div className="account-prompt-card">
        <h2 className="signup-title" style={{ marginBottom: 6 }}>
          Tell us about your business
        </h2>
        <p className="signup-subtitle" style={{ marginBottom: 22 }}>
          We didn't catch this when you signed up. Pick the option that best
          describes what you do — you can change it later.
        </p>

        <button
          type="button"
          className="signup-type-card"
          onClick={() => handleSelect('Supplier')}
          disabled={saving}
        >
          <div className="signup-type-title">Supplier</div>
          <div className="signup-type-desc">
            We manufacture or wholesale promotional products that distributors resell.
          </div>
        </button>

        <button
          type="button"
          className="signup-type-card"
          onClick={() => handleSelect('Distributor')}
          disabled={saving}
        >
          <div className="signup-type-title">Distributor</div>
          <div className="signup-type-desc">
            We sell branded promotional products to end customers.
          </div>
        </button>

        <button
          type="button"
          className="signup-link-button"
          onClick={handleDismiss}
          disabled={saving}
        >
          Ask me later
        </button>
      </div>
    </div>
  );
}

export default AccountTypePrompt;
